import { useFormik } from "formik";
import React from "react";
import { confirmSchema } from "../../validations";

const InputModal = ({
	title,
	detailsComponent,
	descriptions,
	onCloseModal,
	successHandler,
}) => {
	const { values, errors, handleChange, handleSubmit, touched } = useFormik({
		initialValues: {
			confirm: "",
		},
		validationSchema: confirmSchema,
		onSubmit: () => successHandler(),
	});

	return (
		<div className="modal-content">
			<div className="modal-header">
				<h5 className="modal-title" style={{ lineHeight: 1.5 }}>
					{title}
				</h5>
			</div>

			<div className="notification-form modal-body card profile-card password-modal">
				{detailsComponent}
				<div className="row">
					<div className="col-md-12">
						<div className="mb-md-4 mb-3">
							<div className="form-group mb-0">
								<label className="mb-0">Note :</label>
								<br />
								<div style={{ color: "#475f7b" }}>
									<ul style={{ display: "list-item" }}>
										{descriptions.map((descriptionText, index) => {
											return <li key={index}>{descriptionText}</li>;
										})}
									</ul>
								</div>

								<p style={{ marginTop: "10px", marginBottom: "10px" }}>
									Type <b>confirm</b> to proceed
								</p>
								<input
									title=""
									className="form-control"
									id="confirm"
									name="confirm"
									placeholder={`Enter confirm here`}
									value={values.confirm}
									type="text"
									onChange={handleChange}
								/>

								<span className="text-danger d-block">
									{errors.confirm && touched.confirm ? errors.confirm : null}
								</span>
							</div>
						</div>
						<div className="mt-5 text-right">
							<button
								className="btn"
								type="cancel"
								style={{
									margin: "15px",
									backgroundColor: "#FF5B5C",
									color: "white",
									border: "1px solid",
								}}
								onClick={onCloseModal}
							>
								Cancel
							</button>
							<button
								className="btn btn-primary"
								type="submit"
								onClick={handleSubmit}
							>
								Proceed
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default InputModal;
